import { router } from '@inertiajs/react'

/**
 * Re-visits a list page with the current query string plus the given changes.
 * A `null` value removes the param. Every other param (search, filters, Show disabled) is kept,
 * and `page` is reset so pagination applies to the new result set.
 */
export function visitWithParams(path: string, updates: Record<string, string | null>) {
  const params = new URLSearchParams(window.location.search)
  Object.entries(updates).forEach(([key, value]) => {
    if (value) params.set(key, value)
    else params.delete(key)
  })
  params.delete('page')
  const query = params.toString()
  router.visit(query ? `${path}?${query}` : path, { preserveState: true, replace: true })
}
